import React, { useEffect } from 'react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { connect, useDispatch } from 'react-redux';
import { setDeclaration } from '../../../redux/slices/quoteDataSlice';

const HealthDeclarationLogic = ({ fields, healthDeclaration }) => {
  const context = useSitecoreContext();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!healthDeclaration) {
      dispatch(setDeclaration([]));
      return;
    }
    let declaration = {
      workfrontId: context?.sitecoreContext?.route?.itemVersion?.toString(),
      declaration: '',
      declarationDate: '',
      agreed: healthDeclaration,
    };
    if (fields.contentTestId?.value) {
      const agreement = document.querySelector(`[data-testid="${fields.contentTestId.value}"]`);
      if (agreement) {
        declaration = {
          ...declaration,
          declaration: agreement.textContent,
          declarationDate: new Date().toISOString(),
        };
      }
      dispatch(setDeclaration([declaration]));
    }
  }, [healthDeclaration]);

  return <></>;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    healthDeclaration: state.appState?.healthDeclaration,
  };
};
export default connect(mapStateToProps)(HealthDeclarationLogic);
